import React from 'react'
import useSWRImmutable from 'swr/immutable'

import Loading from '../../components/layout/Loading'
import SelectInput from '../../components/form/SelectInput'
import { useI18N } from '../../../libraries/i18n/hook'
import { getAllWorkShifts } from '../../../api/job-offers'

type Props = {
  onChange: (values: { workShiftIds: string[] }) => void,
  values?: string[]
  label?: string
}
const ShiftTypeSelectBox: React.FC<Props> = ({ onChange, values, label }) => {
  const { t } = useI18N()
  const { data, isLoading } = useSWRImmutable('work-shifts', getAllWorkShifts)

  if(isLoading) return <Loading />

  const handleChange = (ids: string[]) => {
    onChange({ workShiftIds: ids })
  }

  const options = data?.map(({ name, id }) => ({ label: name, value: id.toString() }))
  if(!options) return null
  return (
    options && (
      <SelectInput
        isDisabled={options?.length === 0}
        value={options?.filter(workShift => values?.includes(workShift.value.toString()))}
        name='workShiftIds'
        label={label ?? t('jobs.workShift')}
        onChange={handleChange}
        options={options}
        autoMinWidth
      />
    )
  )
}

export default ShiftTypeSelectBox
